/* eslint-disable arrow-body-style */
import http from "./utils";
import { overviewOriginType } from '@/pages/opinion/types/performance';
import { prefix, mockPrefix } from './constants';
import axios from 'axios';
const CancelToken = axios.CancelToken;

export const getGameList: (
  payload: any,
  cancelCallback?: any,
) => Promise<any> | any = (payload, cancelCallback = () => {}) => {
  return http({
    url: `${prefix}/game`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelCallback),
  }) as Promise<any>;
};

export const getGameBasicInfo: (
  payload: { edition_unified_ids: string[] },
) => Promise<any> | any = (payload) => {
  return http({
    url: `${prefix}/game/basic_info`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const getGameGenre: (
  payload: any,
  cancelCallback?: any,
) => Promise<any> | any = (payload, cancelCallback = () => {}) => {
  return http({
    url: `${prefix}/game_genre`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelCallback),
  }) as Promise<any>;
};

export const getCompetitorGameCountryPublisher: (
  payload: any,
  cancelCallback?: any,
) => Promise<any> | any = (payload, cancelCallback = () => {}) => {
  return http({
    url: `${prefix}/game/batch_country_publisher`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelCallback),
  }) as Promise<any>;
};

export const getGameStatsList: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/game/stats`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getGameListTimeline: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/game/timeline`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getGameKeywordFilter: (
  payload: any,
  cancelFunc: any,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelFunc,
) => {
  return http({
    url: `${prefix}/game/keyword_filter`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelFunc),
  }) as Promise<overviewOriginType>;
};

export const getLatelyGameList: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/getLatelyGameList`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getCollectList: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/game/collect_list`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const gameCollectAdd: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/game/collect_add`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const gameCollectDel: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/game/collect_del`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const gameCollectUpdate: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/game/collect_update`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const gameSteamIdFilter: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<any> | any = (payload, cancelTokenFunc = (c: any) => {}) => {
  return http({
    url: `${prefix}/game/steam_id_filter`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;
};

export const getOpinionGamesContentUrl: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<any> | any = (payload, cancelTokenFunc = (c: any) => {}) => {
  return http({
    url: `${prefix}/game/content_url_filter`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;
};
